module.exports = __webpack_public_path__ + "static/media/loading.3ef14b0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.svg
// module id = 1889
// module chunks = 0